import { useLazyQuery, useMutation } from "@apollo/client"
import { ComponentQueryLoader } from "../../../shared/component-query-loader"
import { SystemFlags } from "./system-flags"
import { StaffSystemFlagsContainerApplicantUserQueryDocument, StaffSystemFlagsContainerApplicantUserUpdateDocument } from "../../../../generated"
import { useState } from "react"
import { message } from "antd"

interface SystemFlagsContainerProps {}

export const SystemFlagsContainer: React.FC<SystemFlagsContainerProps> = () => {
    const [selectedApplicantId, setSelectedApplicantId] = useState<string>('')


    const [fetchApplicantSystemFlags, { data, error }] = useLazyQuery(StaffSystemFlagsContainerApplicantUserQueryDocument, {
        variables: {
            applicantId: selectedApplicantId
        }
    })

    const [updateApplicantUser] = useMutation(StaffSystemFlagsContainerApplicantUserUpdateDocument)

    const handleLoad = async () => {
        await fetchApplicantSystemFlags()
    }

    const handleSave = async (systemFlags: string[]) => {
        try {
            const response = await updateApplicantUser({
                variables: {
                    input: {
                        id: selectedApplicantId,
                        applicantUserDetails: {
                            systemFlags
                        }
                    }
                }
            });
            if (response.data?.applicantUserUpdate?.status?.success) {
                message.success('System flags updated successfully for this applicant');
            } else {
                message.error(`Failed to update system flags for this applicant: ${response.data?.applicantUserUpdate?.status?.errorMessage}`);
            }
        } catch (e) {
            message.error('An error occurred while updating system flags for this applicant: ', );
        }
    }
    // Need lazy query for fetching system flags for applicant user by applicant id

    // Need mutation for updating system flags for applicant user

    return (
        <ComponentQueryLoader
            loading={false}
            error={error}
            hasData={true}
            hasDataComponent={
                <SystemFlags
                    onLoad={handleLoad}
                    onSave={handleSave}
                    selectedSystemFlags={data?.applicantUser?.systemFlags as string[]}
                    setSelectedApplicantId={setSelectedApplicantId}
                />
            }
        />
    )

}